import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }

import { useFavicon } from "@vueuse/core";
import { sizes, subscribe, unsubscribe } from "@/utils/media-query";
import {
  getEnvironment,
  isPropertyButtonUrl,
} from "@/utils/system/EnvironmentReader";
import {
  getCurrentInstance,
  reactive,
  onMounted,
  onBeforeUnmount,
  computed,
  inject,
} from "vue";

import { useRoute } from "vue-router";
import * as signalR from "@microsoft/signalr";
import { useNotificationsStore } from "@/stores/NotificationsStore";
import { Environment } from "@/enums/system/Environment";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { useTabsHelper } from "@/utils/tabs/useTabsHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

function getScreenSizeInfo() {
  const screenSizes = sizes() as any;

  return {
    isXSmall: screenSizes["screen-x-small"],
    isSmall: screenSizes["screen-small"],
    isLarge: screenSizes["screen-large"] || screenSizes["screen-x-large"],
    cssClasses: Object.keys(screenSizes).filter((cl) => screenSizes[cl]),
  };
}

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const tabsHelper = useTabsHelper();
const vm = getCurrentInstance() as any;
const title = vm.proxy.$appInfo.title;
const screen = reactive({ getScreenSizeInfo: {} }) as any;
screen.getScreenSizeInfo = getScreenSizeInfo();

function screenSizeChanged() {
  screen.getScreenSizeInfo = getScreenSizeInfo();
}

onMounted(async () => {
  setFavicon();
  subscribe(screenSizeChanged);
  await setupSignalR();
});

onBeforeUnmount(() => {
  unsubscribe(screenSizeChanged);
});

// Setup the listener only once to ensure tab or browser closes are properly tracked to release locks and prevent issues with multiple tabs
window.addEventListener("beforeunload", () => {
  tabsHelper.updateBrowserTabCount(-1);

  let openTabs = tabsHelper.totalOpenTabs();
  if (openTabs <= 1) {
    acquaintApiClient.releaseLocksOnBrowserClose();
  }
});

const cssClasses = computed(() => {
  return ["app"].concat(screen.getScreenSizeInfo.cssClasses);
});

const route = useRoute() as any;

const appClass = computed(() => {
  const loginRoutes = [
    "login-form",
    "reset-password",
    "reset-password-confirmation",
  ];
  return loginRoutes.includes(route.name) ? ["app-login"] : ["app-content"];
});

const setFavicon = () => {
  // To avoid confusion with utility switching customers, ensure favicon is set appropiately
  const favicon = isPropertyButtonUrl() ? "pb.ico" : "favicon.ico";
  useFavicon(favicon);
};

const helpNavigator = inject("HelpNavigator") as any;

window.addEventListener("keydown", (e) => {
  if (e.key === "F1" && !isPropertyButtonUrl()) {
    helpNavigator.LoadHelpTopicFromCurrentRoute();
  }
});

let hubConnection: any;
const notificationStore = useNotificationsStore();

const setupSignalR = async () => {
  hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(notificationStore.getHubUrl())
    .withAutomaticReconnect()
    .build();

  hubConnection.on("broadcastMessage", async (message: any) => {
    await notificationStore.addNotification(message);
  });

  await hubConnection.start();

  if (getEnvironment() == Environment.Development) {
    console.log(
      `SignalR Connection Id: ${hubConnection.connection.connectionId}`,
    );
  }

  await notificationStore.setConnectionId(
    hubConnection.connection.connectionId,
  );
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root",
    class: _normalizeClass(appClass.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(cssClasses.value)
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$route.meta.layout), {
        title: _unref(title),
        "is-x-small": screen.getScreenSizeInfo.isXSmall,
        "is-small": screen.getScreenSizeInfo.isSmall,
        "is-large": screen.getScreenSizeInfo.isLarge
      }, {
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      }, 8, ["title", "is-x-small", "is-small", "is-large"]))
    ], 2)
  ], 2))
}
}

})